import React from 'react';
import { Flex, Text, Radio, Card } from 'pounceV2';
import { LogStreamType } from 'Generated/schema';
import { STREAM_TYPES } from 'Source/constants';
import BetaTagV3 from 'Components/BetaTag/BetaTagV3';
import { useTheme } from '@mui/material';

interface LogStreamTypePickerProps {
  value: LogStreamType;
  excludeCloudwatch: boolean;
  onChange: (value: LogStreamType) => void;
}

const logStreamTypeItems = Object.keys(STREAM_TYPES) as LogStreamType[];

const LogStreamTypePickerV3 = ({
  value,
  onChange,
  excludeCloudwatch,
}: LogStreamTypePickerProps) => {
  const theme = useTheme();
  const excludedTypes = excludeCloudwatch ? [LogStreamType.CloudWatchLogs] : [];
  const availableStreamTypes = logStreamTypeItems.filter(st => !excludedTypes.includes(st));

  return (
    <Flex gap={4} direction="column" width={1} justify="start">
      {availableStreamTypes.map(streamType => (
        <Card variant="inverseRaised" key={streamType}>
          <Flex justify="space-between" align="center" p={3}>
            <Flex direction="column" gap={1}>
              <Flex align="center" gap={2}>
                <Text fontWeight="bold" id={`stream-type-${streamType}-title`}>
                  {STREAM_TYPES[streamType].title}
                </Text>
                {STREAM_TYPES[streamType].isBeta && (
                  <BetaTagV3
                    sx={{ pointerEvents: 'none', px: '6px', py: '3px' }}
                    variant="border"
                    size="small"
                  />
                )}
              </Flex>
              <Text
                color={theme.palette.tokens.content.text.neutral[2]}
                variant="body/sm"
                id={`stream-type-${streamType}-description`}
              >
                {STREAM_TYPES[streamType].description}
              </Text>
            </Flex>
            <Radio
              value={streamType}
              checked={value === streamType}
              onChange={() => onChange(streamType)}
              aria-label={`Select ${streamType} stream type`}
              aria-labelledby={`stream-type-${streamType}-title`}
              aria-describedby={`stream-type-${streamType}-description`}
            />
          </Flex>
        </Card>
      ))}
    </Flex>
  );
};

export default React.memo(LogStreamTypePickerV3);
